import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  template: require('./customer-payment.actions.component.html')
})
export class CustomerPaymentActionsComponent {
  @Input() record: any;

  @Output() onViewMethodsClick: EventEmitter<any> = new EventEmitter();
  @Output() onEditClick       : EventEmitter<any> = new EventEmitter();
}